import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgInfo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M10.38 12.006c-.213 0-.385-.201-.385-.448s.172-.448.385-.448L11 11V8l-.62-.116c-.213 0-.385-.201-.385-.448s.172-.448.385-.448L13 7v4l.619.11c.213 0 .386.201.386.448s-.173.448-.386.448zM11 4h.98c.007 0 .013-.004.02-.004s.013.004.02.004H13v.94c.001.022.012.04.012.061 0 .022-.011.04-.012.061V6h-.967c-.012.001-.022.007-.033.007-.012 0-.022-.006-.033-.007H11v-.939c-.002-.021-.013-.038-.013-.06 0-.021.011-.039.013-.06zM4 8a8 8 0 1016 0A8 8 0 004 8z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Info')(SvgInfo);
